import React, { useState } from 'react'
import { Progress, Button, Form } from 'antd';
//  import Question from './question.json'

import RadioButtons from '../../../components/Questions/RadioButtons'
import Checkboxes from '../../../components/Questions/Checkboxes'
import TextArea from '../../../components/Questions/TextArea';

const HealthCondition = ({ mainNext, Question, formData, setFormData }) => {
    const [current, setCurrent] = useState(0);
    const [parentOfQuestion, setParentOfSubQuestion] = useState(-1);
    const [subQuestion, setShowSubQuestion] = useState(null);
    const [surveyResult, setSurvey] = useState(Question && Question.length ? Question : []);
    const [form] = Form.useForm();

    const renderSingleQuestion = (data) => {

        if (data.questionType === "Radio") {
            return <RadioButtons data={data} />
        } else if (data.questionType === "Checkbox" || data.questionType === "CheckBox") {

            return <Checkboxes data={data} />
        } else if (data.questionType === "TextArea") {
            return <TextArea data={data} />

        }
    }

    const renderQuestions = () => {
        if (surveyResult && surveyResult.length) {
            if (subQuestion) {
                return renderSingleQuestion(subQuestion)
            } else {
                return renderSingleQuestion(Question[current])
            }
        }
    }

    const completeForm = () => {
        form.validateFields().then(data => {
            const selectedValue = Object.values(data)
            surveyResult[current]['selected'] = selectedValue
            setSurvey([...surveyResult]);
            setCurrent(0);
            setShowSubQuestion(null);
            setParentOfSubQuestion(-1)
            mainNext(surveyResult, 'healthCondition');
        }).catch(error => {
            console.log("========== error ======", error)
        })
    }


    const next = () => {
        form.validateFields().then(data => {
            if (parentOfQuestion === -1) {
                let selectedValue = Object.values(data)
                if (surveyResult[current].questionType === "CheckBox") {
                    selectedValue = selectedValue[0];
                }
                surveyResult[current]['selected'] = selectedValue
                setSurvey([...surveyResult]);
                let subQuestion = null

                if (surveyResult[current].questionOptionType === "With Image" && surveyResult[current].questionType === "Radio") {
                    subQuestion = surveyResult[current]['questionOptionImage'][parseInt(selectedValue[0])].subQuestion || null;
                } else if (surveyResult[current].questionOptionType === "Without Image" && surveyResult[current].questionType === "Radio") {
                    subQuestion = surveyResult[current]['questionOption'][parseInt(selectedValue[0])].subQuestion || null;
                }
                if (subQuestion) {
                    setShowSubQuestion(subQuestion);
                    setParentOfSubQuestion(current);
                } else {
                    setCurrent(current + 1);
                }

            } else {
                let selectedValue = Object.values(data);
                if (subQuestion.questionType === "CheckBox") {
                    selectedValue = selectedValue[0];
                }
                const parentSelectedOption = surveyResult[parentOfQuestion].selected;
                if (surveyResult[parentOfQuestion].questionOptionType === "With Image" && surveyResult[parentOfQuestion].questionType === "Radio") {
                    surveyResult[parentOfQuestion]['questionOptionImage'][parseInt(parentSelectedOption[0])].subQuestion['selected'] = [...selectedValue]
                } else if (surveyResult[parentOfQuestion].questionOptionType === "Without Image" && surveyResult[parentOfQuestion].questionType === "Radio") {
                    surveyResult[parentOfQuestion]['questionOption'][parseInt(parentSelectedOption[0])].subQuestion['selected'] = [...selectedValue]
                }

                setShowSubQuestion(null);
                setParentOfSubQuestion(-1)
                setCurrent(current + 1);
            }


        }).catch(error => {
            console.log("========== error ======", error)
        })
    };

    const prev = () => {
        if (subQuestion) {
            setShowSubQuestion(null);
            setParentOfSubQuestion(-1);
            setCurrent(current);
        } else {
            setCurrent(current - 1);
        }
    };

    return (
        <div>
            <Form
                name="basic"
                form={form}
            >
                {renderQuestions()}
                <div className="footer gx-d-flex">
                    <Progress percent={((current / (Question.length - 1)) * 100).toFixed(0)} size="small" />
                    <div className="buttons">
                        <div className="steps-action gx-d-flex " style={{ flexDirection: 'row-reverse' }}>
                            {current < Question.length - 1 && (
                                <Button className="gx-pt-0 gx-mb-0" type="primary" onClick={() => next()}>
                                    Next
                                </Button>
                            )}
                            {current === Question.length - 1 && (
                                <Button className="gx-pt-0 gx-mb-0" type="primary" onClick={() => completeForm()}>
                                    Done
                                </Button>
                            )}
                            {current > 0 && (
                                <Button className="gx-pt-0 gx-mb-0" style={{ margin: '0 8px' }} onClick={() => prev()}>
                                    Previous
                                </Button>
                            )}
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    )
}

export default HealthCondition
